import { FormControlLabel, Grid, MenuItem, Radio, RadioGroup, Select } from '@mui/material';
import { inject, observer } from 'mobx-react';
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import Bottom from './Bottom';
import SignaturePad from './SignaturePad';
import { withRouter } from 'react-router';

const APP_CARDS = [
  { value: 'SHINHAN', label: '신한카드' },
  { value: 'KBPAY', label: '국민카드' },
  { value: 'HYUNDAI', label: '현대카드' },
  { value: 'HANA', label: '하나카드' },
  { value: 'WOORI', label: '우리카드' },
  { value: 'SAMSUNG', label: '삼성카드' },
  { value: 'BC', label: 'BC카드' },
  { value: 'LOTTE', label: '롯데카드' },
];

@inject('commonStore', 'menuStore', 'orderStore')
@observer
class PaymentNiceVan extends Component {
  signResolve = null;
  signReject = null;

  state = {
    isSignaturePadOpen: false,
    selectedRadio: 'appcard',
    appCardCode: 'SHINHAN',
  };

  componentDidMount() {
    this.props.orderStore.setPaymentMethod('SHINHAN');
    this.props.orderStore.setSignData(null);
  }

  handlePayMethodChange = event => {
    const value = event.target.value;
    this.setState({ selectedRadio: value });
    switch (value) {
      case 'kakaopay':
        this.props.orderStore.setPaymentMethod('KKP2');
        break;
      case 'naverpay':
        this.props.orderStore.setPaymentMethod('NAVER');
        break;
      case 'ezwelpay':
        this.props.orderStore.setPaymentMethod('0');
        break;
      default:
        this.props.orderStore.setPaymentMethod(value);
        break;
    }
  };

  handleAppCardChange = event => {
    const code = event.target.value;
    this.setState({ appCardCode: code });
    this.props.orderStore.setPaymentMethod(code);
  };

  handleSignConfirm = dataUrl => {
    this.props.orderStore.setSignData(dataUrl);
    this.setState({ isSignaturePadOpen: false });
    this.signResolve?.();
  };

  handleSignCancel = () => {
    this.setState({ isSignaturePadOpen: false });
    const err = new Error('서명이 취소되었습니다.');
    err.isCancelled = true;
    this.signReject?.(err);
  };

  handleSignEmpty = () => {
    this.props.commonStore.setSnackbar(true, this.props.t('payment.error.inputSign'));
  };

  // 포인트 제외 5만원 초과인 경우 서명 패드를 표시하고 서명 완료 대기
  beforePay = () => {
    const { orderStore } = this.props;
    if (orderStore.paymentAmount <= 50000) return Promise.resolve();

    return new Promise((resolve, reject) => {
      this.signResolve = resolve;
      this.signReject = reject;
      this.setState({ isSignaturePadOpen: true });
    });
  };

  pay = () => {
    const { history, menuStore, orderStore } = this.props;
    const { paymentUrl, orderId } = orderStore.orderAuthData;
    const companyId = menuStore.storeData.companyId;
    const storeCode = menuStore.storeData.storeCode;

    if (orderStore.paymentMethod === 'BC') {
      const form = document.createElement('form');
      form.method = 'POST';
      form.action = paymentUrl;
      document.body.appendChild(form);
      form.submit();
      document.body.removeChild(form);
      return;
    }

    history.push(`/${companyId}/${storeCode}/orders/${orderId}/result`);
  };

  render() {
    const { t, menuStore } = this.props;
    const { isSignaturePadOpen, selectedRadio, appCardCode } = this.state;
    return (
      <React.Fragment>
        <Grid item container direction={'column'} spacing={1} style={{ marginTop: '25px' }}>
          <Grid item>
            <span style={{ fontSize: '13pt', fontWeight: 'bold' }}>{t('payment.label.method')}</span>
          </Grid>
          <Grid item>
            <RadioGroup name="payMethod" value={selectedRadio} onChange={this.handlePayMethodChange}>
              <FormControlLabel value="appcard" control={<Radio color="primary" />} label={'앱 카드'} />
              {selectedRadio === 'appcard' && (
                <Select
                  value={appCardCode}
                  onChange={this.handleAppCardChange}
                  size="small"
                  style={{ marginLeft: '32px', marginBottom: '8px', minWidth: '160px' }}
                >
                  {APP_CARDS.map(card => (
                    <MenuItem key={card.value} value={card.value}>
                      {card.label}
                    </MenuItem>
                  ))}
                </Select>
              )}
              <FormControlLabel value="kakaopay" control={<Radio color="primary" />} label={'카카오페이'} />
              {menuStore.storeData.naverMerchantId && (
                <FormControlLabel value="naverpay" control={<Radio color="primary" />} label={'네이버페이'} />
              )}
              {menuStore.storeData.isEzwelPayUsed && (
                <FormControlLabel value="ezwelpay" control={<Radio color="primary" />} label={'이지웰페이'} />
              )}
            </RadioGroup>
          </Grid>
        </Grid>
        {isSignaturePadOpen && (
          <SignaturePad
            onConfirm={this.handleSignConfirm}
            onCancel={this.handleSignCancel}
            onEmpty={this.handleSignEmpty}
          />
        )}
        <Bottom pay={this.pay} beforePay={this.beforePay} />
      </React.Fragment>
    );
  }
}

export default withTranslation()(withRouter(PaymentNiceVan));
